import Cube from './Cube'

export default Cube
